import { createContext, useContext } from 'react';
import type { FocusRestorableComponent } from './withFocusRestorable.hoc';

export type RestorableFocusContextType = {
  addFocusableComponent: (realFocusKey: string, arg2: FocusRestorableComponent) => void,
  removeFocusableComponent: (realFocusKey: string) => void,
  setLastHoveredRealFocusKey: (lastHoveredRealFocusKey: string) => void
} | undefined;
export const RestorableFocusContext = createContext<RestorableFocusContextType>(undefined);

export type ToggleSpatialNavigationContextType = {
  pauseSpatialNavigation: () => void,
  resumeSpatialNavigation: () => void
} | undefined;
export const ToggleSpatialNavigationContext = createContext<ToggleSpatialNavigationContextType>(
  undefined,
);
export function useToggleSpatialNavigation(): ToggleSpatialNavigationContextType {
  return useContext(ToggleSpatialNavigationContext);
}

export type FocusRestoredContextType = {
  isCursorVisible: boolean,
  isFocusRestored: boolean,
  cursorVisibilityChanged: boolean
} | undefined;
export const FocusRestoredContext = createContext<FocusRestoredContextType>(undefined);
export function useFocusRestoredContext(): FocusRestoredContextType {
  return useContext(FocusRestoredContext);
}
